import { useEffect, useState } from 'react';
import styled from 'styled-components';
import SignUpSerivce from '../../service/signUp/SignUp';
import { formatDate3 } from '../../func/func';
import { useNavigate } from 'react-router-dom';
const FindId = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState<string | null>(null);
  const [sendSms, setSendSms] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [verifiedCode, setVerifiedCode] = useState('');
  const [codeError, setCodeError] = useState<string | null>(null);
  const [isButtonActive, setIsButtonActive] = useState(false);
  const [isVerifiedCode, setIsVerifiedCode] = useState(false); // ✅ API 성공 여부 상태
  const [isCheckCode, setIsCheckCode] = useState(false);
  const [isFindId, setIsFindId] = useState(false);
  const [idList, setIdList] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState<Number>(0);

  useEffect(() => {
    // 숫자가 포함되어 있으면 에러 메시지 설정
    if (/[0-9]/.test(name)) {
      setNameError('숫자는 허용되지 않습니다.');
    } else {
      setNameError('');
    }
  }, [name]);
  const handleNameChange = (e: any) => {
    const newName = e.target.value;
    setName(newName);
  };

  const handlePhoneChange = (e: any) => {
    const value = e.target.value;
    setPhone(value);
    setIsButtonActive(false);
    setIsVerifiedCode(false);
    setIsPhoneValid(false);
    setSendSms(false);
    if (value.length === 0) {
      setPhoneError(null);
      setIsPhoneValid(true);
      return;
    }

    if (!value.startsWith('010')) {
      setPhoneError('휴대폰 형식이 맞지 않습니다.');
      setIsPhoneValid(false);
      return;
    }

    if (value.length !== 11) {
      setPhoneError('휴대폰 번호를 입력하세요.');
      setIsPhoneValid(false);
      return;
    }

    setPhoneError(null);
    setIsPhoneValid(true);
  };

  const handleCodeChange = (e: any) => {
    const value = e.target.value;
    setVerifiedCode(value);
    setIsVerifiedCode(false);
    if (value.length === 0) {
      setCodeError('메시지가 오지 않을 경우 재전송을 눌러주세요.');
      return;
    }

    if (value.length !== 6) {
      setCodeError('인증번호를 6자리 입력해주세요.');
      return;
    }

    if (value.length === 6) {
      setCodeError(null);
      setIsButtonActive(true);
      return;
    }
  };

  const handleVerify = async () => {
    if (!isButtonActive) return;

    setCodeError(null); // 기존 에러 메시지 숨김

    const isValid = await CheckCode();
    if (isValid) {
      setCodeError(null);
      setIsVerifiedCode(true);
    } else {
      setIsVerifiedCode(false);
      setCodeError('인증번호가 일치하지 않습니다. 확인 후 재 입력해 주세요.');
    }
  };

  const CheckCode = async () => {
    try {
      const result = await SignUpSerivce.CheckCode({
        type: 'I',
        loginType: 'C',
        // userid: email,
        tel: phone,
        authCode: verifiedCode,
        name: name,
      });
      setIsCheckCode(result.status === 'success');
      return result.status === 'success';
    } catch (error: any) {
      // alert(error.response.data.message);
      console.log(error);
      setIsCheckCode(false);
      return false;
    }
  };

  const postSms = async () => {
    if (phone === '') {
      alert('휴대폰 번호를 입력해주세요');
      return;
    }
    try {
      const result = await SignUpSerivce.SendSms({
        type: 'I',
        loginType: 'C',
        tel: phone,
        name: name,
      });
      if (result.status === 'success') {
        setSendSms(true);
      }
    } catch (error: any) {
      alert(error.response.data.message);
      console.log(error);
    }
  };

  const findIdAll = async () => {
    if (!isCheckCode) return;
    try {
      const result = await SignUpSerivce.findId({
        name: name,
        phone: phone,
      });
      setIdList(result.data);
      setIsFindId(true);
    } catch (error: any) {
      console.log('error', error);
      console.log(error.response.data.message);
      if (error.response.data.message === '존재하지 않는 사용자입니다.') {
        if (
          window.confirm('등록된 아이디가 없습니다. 회원가입 하시겠습니까?')
        ) {
          navigate('/signUp');
        } else {
          navigate('/');
        }
      }
      setIsFindId(false);
    }
  };

  const renderIcon = (type: string) => {
    if (type === 'K') {
      return {
        img: <img src="/assets/images/Logo/kakao.svg" alt="" />,
        text: '카카오',
      };
    } else if (type === 'N') {
      return {
        img: <img src="/assets/images/Logo/naver.svg" alt="" />,
        text: '네이버',
      };
    } else if (type === 'F') {
      return {
        img: <img src="/assets/images/Logo/facebook.svg" alt="" />,
        text: '페이스북',
      };
    } else if (type === 'G') {
      return {
        img: <img src="/assets/images/Logo/google.svg" alt="" />,
        text: '구글',
      };
    } else {
      return null;
    }
  };
  return (
    <Container>
      {!isFindId ? (
        <FormWrapper>
          <FormBox>
            <FormTitle>성명</FormTitle>
            <SignupInput
              isValid={nameError.length === 0}
              onChange={(e: any) => {
                handleNameChange(e);
              }}
              placeholder="성명을 입력해주세요."
            />
            {nameError.length > 0 && (
              <InputInfoBox isValid={nameError.length === 0}>
                <img
                  src={`/assets/images/icon/${nameError.length === 0 ? 'signUpInfo_icon' : 'signUpInfo_icon_NotValid'}.svg`}
                />
                <ErrorText>{nameError}</ErrorText>
              </InputInfoBox>
            )}
          </FormBox>
          <FormBox>
            <FormTitle>휴대폰 번호</FormTitle>
            <InputBoxWrapper>
              <IdInputBox>
                <SignupInput
                  isValid={(phoneError?.length ?? 0) === 0}
                  onChange={(e: any) => {
                    handlePhoneChange(e);
                  }}
                  placeholder="휴대폰 번호를 입력해주세요."
                  maxLength={11}
                  isavailable={isButtonActive && isVerifiedCode}
                />
                <CheckValidButton
                  onClick={
                    name.length > 0 &&
                    nameError.length === 0 &&
                    isPhoneValid &&
                    phone.length > 0
                      ? () => {
                          postSms();
                        }
                      : () => {}
                  }
                  isValid={
                    name.length > 0 &&
                    nameError.length === 0 &&
                    isPhoneValid &&
                    phone.length > 0
                  }
                  sendYN={sendSms}
                  available={isButtonActive && isVerifiedCode}
                  text={
                    isButtonActive && isVerifiedCode
                      ? '인증완료'
                      : sendSms
                        ? '재전송'
                        : '인증번호발송'
                  }
                >
                  {isButtonActive && isVerifiedCode
                    ? '인증완료'
                    : sendSms
                      ? '재전송'
                      : '인증번호발송'}
                </CheckValidButton>
              </IdInputBox>
              {sendSms && (
                <IdInputBox>
                  <SignupInput
                    isValid={(codeError?.length ?? 0) === 0}
                    onChange={(e: any) => {
                      handleCodeChange(e);
                    }}
                    placeholder="인증번호 6자리를 입력해주세요."
                    maxLength={6}
                    isavailable={isButtonActive && isVerifiedCode}
                  />
                  <CheckValidButton
                    onClick={() => {
                      handleVerify();
                    }}
                    available={isButtonActive && isVerifiedCode}
                    isValid={isPhoneValid && phone.length > 0}
                    text={
                      isButtonActive && isVerifiedCode ? '인증완료' : '확인'
                    }
                  >
                    {isButtonActive && isVerifiedCode ? '인증완료' : '확인'}
                  </CheckValidButton>
                </IdInputBox>
              )}
              {(phoneError?.length ?? 0) > 0 && (
                <InputInfoBox isValid={phoneError?.length === 0}>
                  <img
                    src={`/assets/images/icon/${phoneError?.length === 0 ? 'signUpInfo_icon' : 'signUpInfo_icon_NotValid'}.svg`}
                  />
                  <ErrorText>{phoneError}</ErrorText>
                </InputInfoBox>
              )}
              {(codeError?.length ?? 0) > 0 && (
                <InputInfoBox
                  isValid={
                    codeError?.length === 0 ||
                    (codeError?.includes('재전송') ?? false)
                  }
                >
                  <img
                    src={`/assets/images/icon/${
                      codeError?.length === 0 ||
                      (codeError?.includes('재전송') ?? false)
                        ? 'signUpInfo_icon'
                        : 'signUpInfo_icon_NotValid'
                    }.svg`}
                  />
                  <ErrorText>{codeError}</ErrorText>
                </InputInfoBox>
              )}
            </InputBoxWrapper>
          </FormBox>
          {isCheckCode && (
            <FindIdButton
              onClick={() => {
                findIdAll();
              }}
            >
              아이디 찾기
            </FindIdButton>
          )}
        </FormWrapper>
      ) : (
        <FormWrapper>
          <FindIdTitle>아이디 찾기 결과</FindIdTitle>
          <AccountList>
            {idList &&
              idList.length > 0 &&
              idList.map((item: any, index: any) => (
                <AccountItem
                  key={index}
                  onClick={() => {
                    setSelectedAccount(index);
                    //   setLoginType(item.login_type);
                  }}
                >
                  <AccountItemInner
                    active={selectedAccount === index}
                    loginType={item.login_type}
                  >
                    {selectedAccount === index && item.login_type === 'C' ? (
                      <img
                        src={`/assets/images/check/signUpcheckOn.svg`}
                        alt=""
                      />
                    ) : (
                      <img
                        src={`/assets/images/check/signUpcheckOff.svg`}
                        alt=""
                      />
                    )}

                    <AccountTextBox>
                      <EmailBox>
                        {renderIcon(item.login_type)?.img}
                        {item.login_type === 'C' ? (
                          <span>{item.userid}</span>
                        ) : (
                          <span>
                            {renderIcon(item.login_type)?.text}로 간편 가입한
                            계정
                          </span>
                        )}
                      </EmailBox>
                      <SignUpInfo>
                        <TextGreen
                          style={{
                            visibility: index === 0 ? 'visible' : 'hidden',
                          }}
                        >
                          최근사용
                        </TextGreen>
                        <span>{formatDate3(item.regdate)} 가입</span>
                      </SignUpInfo>
                    </AccountTextBox>
                  </AccountItemInner>
                  {selectedAccount === index && (
                    <ButtonWrapper>
                      {item.login_type === 'C' ? (
                        <FindPasswordBtn
                          onClick={() => {
                            // localStorage.setItem('email', item.userid);
                            // alert('click');
                            navigate('/find', {
                              state: {
                                type: 'password',
                                providedUserid: item.userid,
                                providedPhone: phone,
                                providedName: name,
                              },
                            });
                            //   setTab('pw');
                            //   setType('B');
                          }}
                        >
                          비밀번호 찾기
                        </FindPasswordBtn>
                      ) : (
                        <ErrorText>
                          비밀번호 찾기는 이메일로 가입한 경우에만 가능합니다.
                        </ErrorText>
                      )}
                      <LoginButton
                        onClick={() => {
                          if (item.login_type === 'C') {
                            localStorage.setItem('id', item.userid);
                          }
                          navigate('/login');
                        }}
                      >
                        로그인 하기
                      </LoginButton>
                    </ButtonWrapper>
                  )}
                </AccountItem>
              ))}
            {idList && idList.length === 0 && (
              <>
                <FindIdTitle>등록된 아이디가 없습니다.</FindIdTitle>
                <LoginButton
                  onClick={() => {
                    navigate('/signUp');
                  }}
                >
                  회원가입 하기
                </LoginButton>
              </>
            )}
          </AccountList>
        </FormWrapper>
      )}
    </Container>
  );
};

export default FindId;

const LoginButton = styled.div`
  width: 100%;
  height: 42px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #008aff;
  color: white;
  font-family: Pretendard-Medium;
  font-size: 14px;
  border: none;
  cursor: pointer;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const EmailBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

const TextGreen = styled.span`
  color: #008aff;
`;

const SignUpInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: Pretendard-Medium;
  font-size: 14px;
  color: rgba(55, 56, 60, 0.28);
`;

const AccountTextBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: Pretendard-Bold;
  font-size: 18px;
  color: #222;
`;

const FindPasswordBtn = styled.button`
  width: 100%;
  height: 42px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #008aff;
  color: #008aff;
  font-family: Pretendard-Medium;
  font-size: 16px;
  cursor: pointer;
`;

interface TabProps {
  active: boolean;
  loginType: string;
}

const AccountItemInner = styled.div<TabProps>`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(112, 115, 124, 0.05);
  border-radius: 16px;
  border: ${({ active, loginType }) =>
    active
      ? loginType === 'C'
        ? '1px solid #008aff'
        : '1px solid rgba(236, 79, 79, 1)'
      : 'none'};
`;

const AccountItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const AccountList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  align-items: center;
`;

const FindIdTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 18px;
  font-weight: 700;
  line-height: 34.56px;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const FindIdButton = styled.div`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-family: 'Spoqa Han Sans Neo', 'sans-serif';
  font-weight: 500;
  line-height: 26.4px;
  word-wrap: break-word;
  white-space: nowrap;
  min-width: 118px;
  text-align: center;
  background-color: #008aff;
  color: #ffffff;
  cursor: pointer;
`;

interface InputBoxProps {
  isValid: boolean;
  isavailable?: boolean;
}

const SignupInput = styled.input<InputBoxProps>`
  border-radius: 8px;
  // border: 1px solid #171e2666;
  // border-color: #171e2666;
  padding-inline: 16px;
  padding-block: 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  line-height: 23.2px;
  text-align: left;
  width: 100%;
  border: none;

  ::placeholder {
    color: #171e2666;
  }
  &:focus {
    outline: none; /* 기본 브라우저 스타일 제거 */
    // border: 1px solid #008aff; /* 보라색 테두리 */

    border: 1px solid ${(props) => (props.isValid ? '#008AFF' : 'red')};
  }

  color: ${(props) =>
    props.isavailable ? 'rgba(55, 56, 60, 0.16);' : '#616161'};
  background-color: ${(props) =>
    props.isavailable ? 'rgba(112, 115, 124, 0.08)' : '#F5F7FA'};
`;

const ErrorText = styled.span`
  color: red;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const FormTitle = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  line-height: 23.2px;
  text-align: center;
`;

const FormBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
`;

const InputBoxWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface ValidProps {
  isValid: boolean;
  sendYN?: boolean;
  available?: boolean;
  text?: string;
}

const InputInfoBox = styled.div<ValidProps>`
  color: ${(props) => (props.isValid ? 'rgba(55, 56, 60, 0.61)' : '#FF0000')};
  display: flex;
  flex-direction: row;
  gap: 6px;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const getButtonStyles = (props: ValidProps) => {
  if (props.available) {
    return {
      backgroundColor: '#989BA2',
      color: '#ffffff',
      cursor: 'null',
    };
  }

  if (props.sendYN) {
    return {
      border: '1px solid #008AFF',
      backgroundColor: '#FFFFFF',
      color: '#008AFF',
      cursor: 'pointer',
    };
  }
  if (props.isValid) {
    return {
      backgroundColor: '#008AFF',
      color: '#ffffff',
      cursor: 'pointer',
    };
  }

  return {
    backgroundColor: '#f7f7f8',
    color: '#616161',
    cursor: 'null',
  };
};

const CheckValidButton = styled.div<ValidProps>`
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Spoqa Han Sans Neo', 'sans-serif';
  font-weight: 500;
  line-height: 26.4px;
  word-wrap: break-word;
  white-space: nowrap;
  // min-width: 118px;
  text-align: center;
  border: ${(props) => getButtonStyles(props).border};
  background-color: ${(props) => getButtonStyles(props).backgroundColor};
  color: ${(props) => getButtonStyles(props).color};
  cursor: ${(props) => getButtonStyles(props).cursor};
  width: ${(props) =>
    props.text === '재전송' || props.text === '확인' ? '84px' : 'auto'};
`;

const IdInputBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
`;

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const dummy = [
  {
    login_type: 'C',
    userid: 'ee@ee.e',
    regdate: '2025-02-10T16:13:54.229Z',
  },
  {
    login_type: 'K',
    userid: '3914653036',
    regdate: '2025-02-10T16:09:13.154Z',
  },
  {
    login_type: 'C',
    userid: 't@tt.r',
    regdate: '2025-02-10T15:58:52.168Z',
  },
  {
    login_type: 'C',
    userid: 'pp@p.p',
    regdate: '2025-02-10T15:41:41.928Z',
  },
  {
    login_type: 'C',
    userid: 't@t.tt',
    regdate: '2025-02-09T19:57:53.399Z',
  },
  {
    login_type: 'C',
    userid: 'tf@t.f',
    regdate: '2025-02-05T17:07:37.151Z',
  },
  {
    login_type: 'C',
    userid: '12@1.2',
    regdate: '2025-02-05T17:04:06.580Z',
  },
  {
    login_type: 'C',
    userid: 't@t.t2',
    regdate: '2025-02-05T16:58:51.103Z',
  },
  {
    login_type: 'C',
    userid: 't@t.com',
    regdate: '2025-02-05T16:57:13.356Z',
  },
  {
    login_type: 'C',
    userid: 'test@test.test',
    regdate: '2025-02-04T23:31:12.653Z',
  },
  {
    login_type: 'C',
    userid: 't@t.t',
    regdate: '2025-02-04T19:36:59.550Z',
  },
  {
    login_type: 'C',
    userid: 'test1@test.test',
    regdate: '2025-02-03T22:21:42.708Z',
  },
  {
    login_type: 'C',
    userid: 'bia',
    regdate: '2024-07-09T18:48:44.990Z',
  },
  {
    login_type: 'C',
    userid: 'dongil',
    regdate: '2024-06-06T22:55:52.326Z',
  },
];
